const BEACON_PATH = '/beacon';

const sanitize = (part: string) => part.replace(/[^\w-]+/g, '_').slice(0, 60);

/**
 * Sends an empty request to `/beacon/<event>` so the event is visible in the access log.
 * Never put personal data into the event name.
 */
export const sendBeacon = (...parts: (string | undefined)[]) => {
  if (import.meta.server || typeof window === 'undefined') {
    return;
  }
  const event = parts
    .filter((part): part is string => !!part)
    .map(sanitize)
    .join('.');
  const url = `${BEACON_PATH}/${event}`;

  try {
    if (typeof navigator.sendBeacon === 'function') {
      navigator.sendBeacon(url);
    } else {
      void fetch(url, { method: 'POST', keepalive: true }).catch(() => undefined);
    }
  } catch {
    // Beacons must never break the user flow.
  }
};
